import React, { Component } from 'react';

export default class Paging extends Component {
    render() {
        return (
            <div className="paging vcenter">
                <span className="pageInfo">1/3</span>

                <div className="btn-group">
                    <button type="button" className="btn pageUp"></button>
                    <button type="button" className="btn pageDown"></button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/react/common/Paging.react.js